
import { Toast, PullRefresh, Dialog } from "vant";
Vue.use(PullRefresh);
import { Component, Vue } from "vue-property-decorator";
import { logout } from "@/req/login";
import NavBar from "@/components/navBar.vue";
import itemList from "./item.vue";
@Component({
  components: { itemList, NavBar },
})
export default class Logout extends Vue {
  public active: any = 1;
  public count = 0;
  public isLoading = false;
  public navList = [
    {
      id: 1,
      name: "我买到的",
    },
    {
      id: 2,
      name: "我卖出的",
    },
    {
      id: 3,
      name: "指定我",
    },
  ];
  public isIOs = false;

  public mounted() {
    //   url截取token
    // const obj: any = this.$fn.parseQuery(window.location.href);
    if (this.$fn.cookies.getIsios()) {
      this.isIOs = true;
    }
  }
  public onClickLeft() {
    Toast("返回");
  }
  public onRefresh() {
    setTimeout(() => {
      Toast("刷新成功");
      this.isLoading = false;
      this.count++;
    }, 1000);
  }
  public onLogout() {
    this.$dialog
      .alert({
        message: "是否退出登录",
        showCancelButton: true,
        confirmButtonColor: "#000",
      })
      .then(async () => {
        const res = await logout({ token: this.$fn.cookies.getToken() });
        localStorage.removeItem("tempLogin");
        this.$fn.cookies.removeToken();
        (window as any).location.reload();
      })
      .catch(() => {
        // on cancel
      });
  }
  public showAlert(num) {
    let message = "";
    let url = "";
    if (!this.$fn.cookies.getToken()) {
      message = "请先登录后再操作";
      url = "login";
      this.dialog(message, url);
      return;
    } else if (this.$store.state.user.info.auth_status != 1) {
      message = "账号未实名认证，请先进行实名认证";
      url = "verificationCode";
      this.dialog(message, url);
      return;
    }
    // Dialog.alert({
    //   //   title: "为保障您的交易安全提现请下载996盒子",
    //   message: "为保障您的交易安全提现请下载996盒子",
    //   theme: "round-button",
    //   confirmButtonText: "下载996盒子",
    //   className: "confirmButtonColor",
    //   closeOnClickOverlay: true,
    // }).then(() => {
    //   // on close
    // });
    const typeNum: any = num;
    this.$router.push({ name: "newExtract", params: { type: typeNum }, query: { type: typeNum } });
    // this.$router.push({ name: "extract" });
  }
  public dialog(msg, url) {
    this.$dialog
      .alert({
        message: msg,
        showCancelButton: true,
        confirmButtonColor: "#000",
      })
      .then(async () => {
        this.$router.push({ name: url });
      })
      .catch(() => {
        // on cancel
      });
  }
}
